import { GeneralError } from "./general-error";

type Props = {
  withLayout?: boolean;
};

export function NotFoundError(props?: Props) {
  const withLayout = props?.withLayout ?? false;
  return (
    <GeneralError title="404" withLayout={withLayout} />
  );
}
